import { render, staticRenderFns } from "./MiniDepStatTableReg.component.vue?vue&type=template&id=34cc88eb&scoped=true&"
import script from "./MiniDepStatTableReg.component.vue?vue&type=script&lang=js&"
export * from "./MiniDepStatTableReg.component.vue?vue&type=script&lang=js&"
import style0 from "./MiniDepStatTableReg.component.vue?vue&type=style&index=0&id=34cc88eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cc88eb",
  null
  
)

export default component.exports